export const actionFilterTabs = [
  { key: "ALL", label: "전체" },
  { key: "OVERDUE", label: "기한 초과" },
  { key: "DELIVERY_RISK", label: "납기 위험" },
  { key: "PLAN_REVIEW", label: "계획 확인" },
  { key: "CHANGE_REVIEW", label: "변경 검토" },
];

export const getActionCategory = (item) => {
  if (item?.risk_level === "OVERDUE" || item?.exception_type === "OVERDUE") return "OVERDUE";
  if (item?.risk_level === "HIGH" || ["HIGH_RISK", "DELIVERY_RISK"].includes(item?.exception_type)) {
    return "DELIVERY_RISK";
  }
  if (
    ["CHANGE_REVIEW"].includes(item?.schedule_status) ||
    ["CHANGE_REVIEW"].includes(item?.exception_type) ||
    item?.production_plan_status === "REPLAN_REQUIRED"
  ) {
    return "CHANGE_REVIEW";
  }
  if (
    ["CHECK_REQUIRED", "PLAN_REVIEW"].includes(item?.schedule_status) ||
    ["CHECK_REQUIRED", "PLAN_REVIEW", "CUSTOMER_CHECK"].includes(item?.exception_type) ||
    item?.production_plan_status === "NOT_REVIEWED"
  ) {
    return "PLAN_REVIEW";
  }
  return "ALL";
};

export const filterActionItemsByTab = (items = [], selectedTab = "ALL") => {
  if (selectedTab === "ALL") return items;
  return items.filter((item) => getActionCategory(item) === selectedTab);
};

export const getActionTabCounts = (items = []) =>
  items.reduce(
    (acc, item) => {
      const category = getActionCategory(item);
      acc.ALL += 1;
      acc[category] = (acc[category] || 0) + 1;
      return acc;
    },
    { ALL: 0, OVERDUE: 0, DELIVERY_RISK: 0, PLAN_REVIEW: 0, CHANGE_REVIEW: 0 }
  );
